import { formatUptimeCellValue } from '@ipfabric/utils';
import { humanizeDurationUnitMeasures } from '@ipfabric/utils/utils/humanizeDurationUnitMeasures';

const uptimeToNumber = (value: string): number | null => {
  try {
    const split = value.split(',').filter((v) => v !== '');
    if (!split || !split.length) {
      return null;
    }
    // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: reasonable
    const seconds = split.reduce((acc, val) => {
      try {
        const extract = val.match(/[0-9]+/);
        if (!extract || !extract.length) {
          return acc;
        }
        const number = Number(extract[0]);
        if (/year/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.y / 1000);
        }
        if (/month/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.mo / 1000);
        }
        if (/week/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.w / 1000);
        }
        if (/day/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.d / 1000);
        }
        if (/hour/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.h / 1000);
        }
        if (/minute/.test(val)) {
          return acc + number * (humanizeDurationUnitMeasures.m / 1000);
        }
        if (/second/.test(val)) {
          return acc + number;
        }
        return acc;
      } catch {
        return acc;
      }
    }, 0);
    if (!seconds || Number.isNaN(seconds)) {
      return null;
    }
    return seconds;
  } catch {
    return null;
  }
};

const uptimeToString = (value: number): string => {
  return formatUptimeCellValue(value) ?? '';
};

export const uptimeValueConvertor = {
  toNumber: uptimeToNumber,
  toString: uptimeToString,
};
